import { useFetchInvoicesSummary } from '@features/invoices/hooks/useFetchInvoicesSummary'
import { useFetchQuotesSummary } from '@features/invoices/hooks/useFetchQuotesSummary'

export const usePrefetchClientDocumentsSummary = (customerId?: string) => {
  const { isLoading: isLoadingInvoicesSummary } = useFetchInvoicesSummary({
    customerId,
    enabled: !!customerId,
  })

  const { isLoading: isLoadingQuotesSummary } = useFetchQuotesSummary({
    customerId,
    enabled: !!customerId,
  })

  return { isLoading: !!customerId && (isLoadingInvoicesSummary || isLoadingQuotesSummary) }
}
